import { mergeAll } from 'lodash/fp';

import bdc from './bdc';
import thd from './thd';
import getFuncBySite from '../../utils/getFuncBySite';
import { sites } from '../../helpers/globalVariables';

const defaultOptions = {
  designId: '',
  selectedProducts: [],
  leafItems: [],
  productOnlyItems: [],
  options: {
    createAndSaveJob: {},
    cartProducts: true,
  },
};

export default cartingOptions => getFuncBySite({
  [sites.blinds]: bdc,
  [sites.theHomeDepot]: thd,
})(mergeAll([defaultOptions, cartingOptions]));
